/** @format */

import template from './gb-purchase-item-amount-label.html';
import './gb-purchase-item-amount-label.scss';

export const GbPurchaseItemAmountLabelComponent = {
    template,
    controller: class GbPurchaseItemAmountLabelComponent {
        constructor() {
            'ngInject';
        }
    },
};
